/* Isabgol vs Fibre+ listicle — pack selection, sticky bar, AJAX add to cart.
   No jQuery. Follows the theme's landing-page contract: POST /cart/add.js then
   dispatch cart:refresh with openMiniCart so Focal's <cart-drawer> opens itself. */
(function () {
  'use strict';

  function initOffer(root) {
    if (!root || root.dataset.isbInit === '1') return;
    root.dataset.isbInit = '1';

    var plansEl = root.querySelector('[data-isb-plans]');
    var cta     = root.querySelector('[data-isb-cta]');
    var errEl   = root.querySelector('[data-isb-error]');
    if (!plansEl || !cta) return;

    var sectionId = root.getAttribute('data-section-id');
    var bar       = document.querySelector('.isb-sticky[data-section-id="' + sectionId + '"]');
    var barBtn    = bar && bar.querySelector('[data-isb-bar-btn]');
    var barMrp    = bar && bar.querySelector('[data-isb-bar-mrp]');
    var barPay    = bar && bar.querySelector('[data-isb-bar-pay]');
    var barSave   = bar && bar.querySelector('[data-isb-bar-save]');

    var busy = false;

    function selected() {
      return plansEl.querySelector('.isb-plan.is-selected') || plansEl.querySelector('.isb-plan');
    }

    function sync(card) {
      Array.prototype.forEach.call(plansEl.querySelectorAll('.isb-plan'), function (el) {
        el.classList.toggle('is-selected', el === card);
        var input = el.querySelector('input');
        if (input) input.checked = (el === card);
      });
      if (!bar) return;
      var pay     = card.getAttribute('data-price-formatted') || '';
      var compare = card.getAttribute('data-compare-formatted') || '';
      var save    = card.getAttribute('data-save-formatted') || '';
      if (barPay) barPay.textContent = pay;
      if (barMrp) {
        barMrp.textContent = compare;
        barMrp.parentNode.hidden = !compare;
      }
      if (barSave) {
        barSave.textContent = save ? 'Save ' + save : '';
        barSave.hidden = !save;
      }
    }

    plansEl.addEventListener('change', function (e) {
      var card = e.target.closest ? e.target.closest('.isb-plan') : null;
      if (card) sync(card);
    });
    plansEl.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('.isb-plan') : null;
      if (card) sync(card);
    });

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.classList.add('is-visible');
      setTimeout(function () { errEl.classList.remove('is-visible'); }, 3500);
    }

    function setLabel(btn, text, added) {
      if (!btn) return;
      var span = btn.querySelector('[data-isb-label]');
      (span || btn).textContent = text;
      btn.classList.toggle('is-added', !!added);
    }

    function addToCart(btn) {
      if (busy) return;
      var card = selected();
      if (!card) { showError('Please choose a pack size.'); return; }
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId) { showError('This pack is unavailable right now.'); return; }

      busy = true;
      var original = btn.getAttribute('data-label') || 'Add to cart';
      if (btn) { btn.disabled = true; }

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ['mini-cart'] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { openMiniCart: true }
          }));
          // setLabel(btn, 'Added ✓', true);
          // setTimeout(function () { setLabel(btn, original, false); }, 2000);
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
          // setLabel(btn, original, false);
        })
        .then(function () {
          busy = false;
          if (btn) btn.disabled = false;
        });
    }

    cta.addEventListener('click', function () { addToCart(cta); });
    if (barBtn) barBtn.addEventListener('click', function () { addToCart(barBtn); });

    /* sticky bar shows once the in-page CTA has scrolled out of view */
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(cta);
    } else if (bar) {
      bar.classList.add('is-visible');
    }

    var pre = plansEl.querySelector('.isb-plan.is-selected');
    if (pre) sync(pre);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isb-offer]'), initOffer);
  }

  /* smooth scroll for the jump chips, without a global html rule */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.isb [data-isb-scroll]') : null;
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-isb-offer]') : null;
    if (el) initOffer(el);
  });
})();
